import styles from "./authen.module.css";
import { Modal, Button } from 'antd';
import { ResponseDataType } from 'api';
import { getRequest, postRequest } from 'api';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { removeStorage } from 'utils';

export const ConfirmForgotPassword = () => {
  const { customerId, key } = useParams();
  const navigate = useNavigate();

  const [isVerified, setIsVerified] = useState<boolean | null>(null);
  const [email, setEmail] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string | string[]>('');

  useEffect(() => {
    const getEmail = async () => {
      const res: ResponseDataType<{email: string}> = await getRequest(
        `/auth/get-customer-email?_id=${customerId}`
      );
      if (res?.data?.email) {
        setEmail(res.data.email);
      } else {
        setEmail('example@example.com');
      }
    };

    getEmail();
  }, [customerId]);

  const renderErrorMessage = (message: string | string[]) => {
    if (typeof message === 'object') {
      return (
        <>
          {message.map((msg: string) => (
            <p>{msg}</p>
          ))}
        </>
      );
    } else return message;
  };

  useEffect(() => {
    const ConfirmEmail = async () => {
      const data: ResponseDataType<{}> = await postRequest(
        "/auth/confirm-forgot-password",
        {
          customerId: customerId,
          token: key
        }
      );
      if (data?.code) {
        // Modal.error({
        //   style: { fontFamily: 'Quicksand' },
        //   title: 'Xin lỗi!',
        //   content: renderErrorMessage(data.message),
        //   onOk() {
        //     navigate('/');
        //   },
        // });
        setIsVerified(false);
        setErrorMessage(data.message);
      } else
        // Modal.success({
        //   style: { fontFamily: 'Quicksand' },
        //   title: 'Thành công!',
        //   content: 'Kích hoạt tài khoản thành công',
        //   onOk() {
        //     removeStorage();
        //     navigate('/availableAccount', {state: {customerId: customerId, token: key}});
        //   },
        // });
        setIsVerified(true);
        removeStorage();
    };

    ConfirmEmail();
  }, [customerId, key, navigate]);

   if (isVerified === false) {
    Modal.error({
      style: { fontFamily: 'Quicksand' },
      title: 'Xin lỗi!',
      content: renderErrorMessage(errorMessage),
      onOk() {
        navigate('/');
      },
    });
    return null;
  }

  if (isVerified === true) {
    return (
      <div className={styles.activation_page}>
      <img
        style={{
          marginTop: "16px",
          marginRight: "16px",
          height: "32px",
          width: "32px",
          float: "right",
        }}
        src="/Images/logo.png"
        alt=""
      />
      <div className={styles.authen_wrapper}>
        <div className={styles.name}>Adot</div>
        <div className={styles.activation_text}>
          <span style={{ marginRight: "4px" }}>Mật khẩu email</span>
          <div style={{ fontWeight: 900 }}> { email } </div>&nbsp;
        </div>
        <div className={styles.activation_text}>
          của bạn đã được đổi thành công.
        </div>
        <Button
          type="primary"
          className={styles.authen_button}
          style={{marginBottom: 30}}
          onClick={() => {
            navigate("/login");
          }}
        >
          Đăng nhập
        </Button>
      </div>
    </div>
    );
  }
  return null; 
};